import { ProductionReportConfig } from './production-reports.models';
import {
  PRODUCTION_MGA_PAID_REPORT,
  PRODUCTION_PERSONAL_PAID_REPORT,
  PRODUCTION_RMD_PAID_REPORT,
} from './production-reports.config.paid';
import {
  PRODUCTION_MGA_SUBMIT_REPORT,
  PRODUCTION_PERSONAL_SUBMIT_REPORT,
  PRODUCTION_RMD_SUBMIT_REPORT,
} from './production-reports.config.submit';

export const PRODUCTION_PRECONFIGURED_REPORTS: ProductionReportConfig[] = [
  PRODUCTION_MGA_PAID_REPORT,
  PRODUCTION_PERSONAL_PAID_REPORT,
  PRODUCTION_RMD_PAID_REPORT,
  PRODUCTION_MGA_SUBMIT_REPORT,
  PRODUCTION_PERSONAL_SUBMIT_REPORT,
  PRODUCTION_RMD_SUBMIT_REPORT,
];
